import React from 'react';

import PopOverMenu from '../../PopOverMenu';
import InfoButton from '../../InfoButton';

const MemberCard = (props) => {
    const {
        firstName,
        lastName,
        email,
        menuOptions,
        menuOnSelected,
        'data-testid': dataTestId,
    } = props;

    const infoText = () => {
        return (
            <div>
                <strong data-testid="member-card.missing-profile-tooltip.title">Missing Player Profile</strong><br />
                <p data-testid="member-card.missing-profile-tooltip.description">
                    UTR Sports account member is <b>still registered</b> for this event but does not appear on the players list because they are <b>missing a player profile</b>. The player can
                    (with <a href="https://docs.google.com/presentation/d/16s3G5DDZOYumGrTwb3fcS2QaxQKazq9-sNa6rKFU8mE/edit#slide=id.g37ea9c1b17_0_1" target="_blank" rel="noopener noreferrer" data-testid="member-card.missing-profile-tooltip.guide-link">this guide</a> as reference):
                </p>
                <p data-testid="member-card.missing-profile-tooltip.step1">
                    1) Activate their correct profile
                </p>
                <br />
                <p data-testid="member-card.missing-profile-tooltip.or-label">OR</p>
                <br />
                <p data-testid="member-card.missing-profile-tooltip.step2">
                    2) If their profile is activated by another UTR Sports account that they can access, they can either:
                </p>
                <ul>
                    <li data-testid="member-card.missing-profile-tooltip.option-deactivate">
                        Deactivate the profile from that account and reactivate the profile with this account already registered for this event or
                    </li>
                    <li data-testid="member-card.missing-profile-tooltip.option-withdraw">
                        You can withdraw this registration and they can re-register (if they haven’t already) with the other account that has the correct player profile.
                    </li>
                </ul>
            </div>
        );
    };

    return (
        <div className="player-card">
            <div className={`list-view`}>
                <div className="row">
                    <div className="col-md-6">
                        <div className="name-and-place">
                            <div className="name" data-testid={dataTestId && `${dataTestId}.name`}>{firstName} {lastName} ({email})</div>
                        </div>
                    </div>
                    <div className="col-md-5 text-lighter" data-testid={dataTestId && `${dataTestId}.missing-profile`}>Missing Player Profile <InfoButton hoverText={infoText()} /></div>
                    <div className={`col-md-1`}>
                        {menuOptions && (
                            <PopOverMenu
                                horizontalEllipsis={true}
                                menuItems={menuOptions}
                                onSelected={menuOnSelected}
                                data-testid={dataTestId && `${dataTestId}.menu`}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

MemberCard.defaultProps = {
    'data-testid': null,
};

export default MemberCard;
